import { createSlice } from "@reduxjs/toolkit";

export interface IShopState {
  id?: string;
  accessToken?: string;
  active?: boolean;
  appSettings?: {
    id: string;
    useFreeMode: boolean;
    createdAt: Date | string;
    updatedAt: Date | string;
  };
  appSettingsId?: string;
  contactEmail?: string;
  currencyCode?: string;
  email?: string;
  myshopifyDomain?: string;
  name?: string;
  plan?: string;
  primaryDomain?: string;
  productsSynchronization?: boolean;
  rejectedActions?: string[];
  shopifyAppSubscription?: {
    id: string;
    shopId: string;
    shopifySubscriptionId: string;
    name: string;
    status: string;
    lineItems: any[];
    subscriptionCreatedAt: Date | string;
    currentPeriodEnd: Date | string;
    createdAt: Date | string;
    trialDays: number;
  }
  subscriptionPlan?: {
    id: string;
    name: string;
    monthlyPrice: number | null,
    yearlyPricePerMo: number | null,
    crossedPrice: number | null,
    collectionsLimit: number | null;
    productsLimit: number | null;
    createdAt: Date | string;
    updatedAt: Date | string;
  } | null;
  subscriptionPlanId?: string | null;
  trialUseDate?: Date | string;
  createdAt?: Date | string;
  updatedAt?: Date | string;
  url?: string;
  productsCount?: number;
}

const initialState = {
  data: null
};

export const shop = createSlice({
  name: "shop",
  initialState,
  reducers: {
    updateShop(state, action) {
      state.data = action.payload;
    }
  }
});

export const { updateShop } = shop.actions;

export default shop.reducer;